import { useMemo } from 'react';

import { useGetDxfScene } from '@frontend/api';

import { resolveDxfSceneLoadInput } from '../session/resolveDxfSceneLoadInput';
import type { DxfSceneLoadInput } from '../session/types';

/**
 * React Query boundary for the drawing. Maps the fetch into a discriminant
 * the session can load — Viewer.tsx never sees DxfScene.
 */
export const useDxfSceneLoad = (sceneUrl: string | null): DxfSceneLoadInput => {
  const { data: scene, isError, error } = useGetDxfScene(sceneUrl ?? undefined);

  return useMemo(
    () =>
      resolveDxfSceneLoadInput({
        sceneUrl,
        scene,
        isError,
        error,
      }),
    [sceneUrl, scene, isError, error],
  );
};
